import { Component, Input, OnInit } from '@angular/core';

export interface IBoxInfo {
  title: string;
  data: string;
}

@Component({
  selector: 'info-box',
  template: require('./info-box.component.html'),
  styles: [require('./info-box.component.scss')],
})
export class InfoBoxComponent implements OnInit {
  @Input() boxInfo: IBoxInfo;
  icon: string;

  ngOnInit(): void {
    const hasData = this.boxInfo.data !== null && this.boxInfo.data !== undefined;
    if (!hasData) this.icon = 'dash';
  }
}
